import { render } from "./TodosList.vue?vue&type=template&id=68748013"
import script from "./TodosList.vue?vue&type=script&lang=js"
export * from "./TodosList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__